import { useEffect, useState } from 'react';
import { useTimer } from 'react-timer-hook';
import cn from '@/lib/clsxm';
import { addToTime } from '@/lib/date';
import useOTPAuthStore from '@/store/otp-auth-store';

import localization from '@/constant/localization';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import { addZeroIfUnder10, toMilliSecond } from '@/lib/helper';
import { usePostRetry } from '@/services/hooks';
import { useSearchParams } from 'react-router-dom';
import useHomeStore from '@/store/home';

export default function Retry({className, otpExpireDate, phoneNumber, clearOtpField}: {className?: string, phoneNumber: string, otpExpireDate?:number, clearOtpField: () => void}) {
  const {mutate: reqRetryOtp} = usePostRetry()
  const { setOtpTokenLength } = useHomeStore();
  const [searchParams] = useSearchParams();
  const pgc = searchParams.get('pgc');
  const [active, setActive] = useState(false);
  const { minutes, seconds, restart } = useTimer({
    expiryTimestamp: new Date(),
    onExpire: () => !active && setActive(true),
  });
  const sendRequest = () => {
    active && reqRetryOtp({
        mobile: phoneNumber,
        paymentGatewayCode: pgc!
      }, {
        onSuccess: (res) => {
          if (active && res.tokenExpireTime) {
            const time = new Date(toMilliSecond(res.tokenExpireTime))
            restart(time);
            setActive(false);
            setOtpTokenLength(res.otpCount)
            clearOtpField()
          }
        }
      })
  };
  useEffect(() => {
    if(otpExpireDate) {
      const time = new Date(toMilliSecond(otpExpireDate))
      restart(time);
      setActive(false);
    }
  }, [otpExpireDate]);
  return (
    <Container center className='justify-center gap-1 mt-6'>
      <Text
        onClick={sendRequest}
        className={cn(
          'text-sm font-medium text-grayLight-500 dark:text-grayDark',
          active && 'cursor-pointer text-black dark:text-grayLight-0',
          active && className && className,
        )}
      >
        {/*toReceiveOtp*/}
        {active ? localization.requestOTPAgain : <span>{localization.toReceiveOtp}<span className='text-black text-base font-medium dark:text-white'>{addZeroIfUnder10(minutes)}:{addZeroIfUnder10(seconds)}</span></span>}
      </Text>
    </Container>
  );
}
